import { graphql } from "@opensea/graphql"

export const ActivityQuantityFragment = graphql(`
  fragment ActivityQuantity on Activity {
    __typename
    quantity
  }
`)
